<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized">
  <runner-workout-view [clientProgramWorkoutDayId]="clientProgramWorkoutDayId" (saved)="workoutSaved()" [isCoachView]="false"></runner-workout-view>
</div>

